import React from 'react';
import DayBook from './Day_Book';
import '../../../CommonCSS/SocietyCSS.css'

const DayBookApp = () => {
  return (

    <div className="app-wrapper">
      <div className="form-container">
        <div className='card' style={{borderRadius: '8px'}}>
          <div className="card-header-css" style={{borderRadius: '8px', textAlign: 'center' }} >
            <h5>Day Book Report</h5>
          </div>
        </div>
        <DayBook />
      </div>
    </div >
  );
};

export default DayBookApp;
